import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'consigneds';

// GET
export const getConsigneds = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createConsigneds = async (values, route = '') => {
  try {
    const { data } = await api.post(`/${endPoint}/${route}`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data.data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateConsigneds = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data.data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteConsigneds = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data.data;
  } catch (error) {
    errorHandler(error);
  }
};

getConsigneds.propTypes = {
  values: PropTypes.object.isRequired,
};

createConsigneds.propTypes = {
  values: PropTypes.object.isRequired,
};

updateConsigneds.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteConsigneds.propTypes = {
  id: PropTypes.string.isRequired,
};
